import { render, staticRenderFns } from "./products-prices-groups-input.vue?vue&type=template&id=dda4d120&"
import script from "./products-prices-groups-input.vue?vue&type=script&lang=js&"
export * from "./products-prices-groups-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports